export default "__VITE_ASSET__DckizLDz__"